import React from "react";
import { useTranslation } from "react-i18next";
import { Carousel, CarouselContent, CarouselItem } from "../ui/carousel";
import Autoplay from "embla-carousel-autoplay";

const Customers: React.FC = () => {
  const { t } = useTranslation("common");

  return (
    <div>
      <h2 className="text-3xl font-bold text-center mb-12" id="customers">
        {t("customers")}
      </h2>

      <Carousel
        className="w-full m-3"
        opts={{ loop: true }}
        plugins={[
          Autoplay({
            delay: 2000,
          }),
        ]}
      >
        <CarouselContent>
          <CustomerItem customer={t("customersList.gnb")} />
          <CustomerItem customer={t("customersList.lspd")} />
          <CustomerItem customer={t("customersList.sheffield")} />
          <CustomerItem customer={t("customersList.doof")} />
          <CustomerItem customer={t("customersList.hooli")} />
          <CustomerItem customer={t("customersList.pollos")} />
          <CustomerItem customer={t("customersList.hhmg")} />
        </CarouselContent>
      </Carousel>
    </div>
  );
};

function CustomerItem({ customer }: { customer: String }) {
    return (
        <CarouselItem className="basis-1/3 pl-10">
            <div className="bg-gray-600 p-3 rounded-sm">
                <h1 className="text-white override text-center">{customer}</h1>
            </div>
        </CarouselItem>
    )
}

export default Customers;